module.exports = __webpack_public_path__ + "static/img/frame 0.a971054a.png";